/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_TeamsInputs */

const th_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทีม`)
};

const en_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

const ja_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チーム`)
};

const zh_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球队`)
};

const es_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipos`)
};

const pt_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Times`)
};

const id_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim`)
};

const fr_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Équipes`)
};

const tl_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga team`)
};

const vi_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đội`)
};

const ko_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팀`)
};

const de_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

const ru_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команды`)
};

const tr_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takımlar`)
};

const it_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Squadre`)
};

const pl_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drużyny`)
};

const uk_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команди`)
};

const hi_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीमें`)
};

const ar_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفرق`)
};

const ms_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasukan`)
};

const bn_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দল`)
};

const zh_tw2_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球隊`)
};

const zh_hk2_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球隊`)
};

const ur_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ٹیمیں`)
};

const fa_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تیم‌ها`)
};

const sw_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timu`)
};

const nl_admin_teams = /** @type {(inputs: Admin_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

/**
* | output |
* | --- |
* | "Teams" |
*
* @param {Admin_TeamsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const admin_teams = /** @type {((inputs?: Admin_TeamsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_TeamsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_admin_teams(inputs)
	if (locale === "ja") return ja_admin_teams(inputs)
	if (locale === "zh") return zh_admin_teams(inputs)
	if (locale === "es") return es_admin_teams(inputs)
	if (locale === "pt") return pt_admin_teams(inputs)
	if (locale === "id") return id_admin_teams(inputs)
	if (locale === "fr") return fr_admin_teams(inputs)
	if (locale === "tl") return tl_admin_teams(inputs)
	if (locale === "vi") return vi_admin_teams(inputs)
	if (locale === "ko") return ko_admin_teams(inputs)
	if (locale === "de") return de_admin_teams(inputs)
	if (locale === "ru") return ru_admin_teams(inputs)
	if (locale === "tr") return tr_admin_teams(inputs)
	if (locale === "it") return it_admin_teams(inputs)
	if (locale === "pl") return pl_admin_teams(inputs)
	if (locale === "uk") return uk_admin_teams(inputs)
	if (locale === "hi") return hi_admin_teams(inputs)
	if (locale === "ar") return ar_admin_teams(inputs)
	if (locale === "ms") return ms_admin_teams(inputs)
	if (locale === "bn") return bn_admin_teams(inputs)
	if (locale === "zh-TW") return zh_tw2_admin_teams(inputs)
	if (locale === "zh-HK") return zh_hk2_admin_teams(inputs)
	if (locale === "ur") return ur_admin_teams(inputs)
	if (locale === "fa") return fa_admin_teams(inputs)
	if (locale === "sw") return sw_admin_teams(inputs)
	if (locale === "nl") return nl_admin_teams(inputs)
	return en_admin_teams(inputs)
});